import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "button__left-slot"
}
const _hoisted_2 = {
  key: 1,
  class: "button__sign"
}
const _hoisted_3 = { class: "button__sign-main" }
const _hoisted_4 = {
  key: 0,
  class: "button__sign-hint"
}
const _hoisted_5 = {
  key: 2,
  class: "button__right-slot"
}
const _hoisted_6 = {
  key: 3,
  class: "button__loader"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z",
    class: "button__loader-circle",
    fill: "currentColor"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]

import { withDefaults, computed, useSlots, onMounted } from "vue";
import { TirPmButtonSizeEnum, TirPmButtonVariantEnum } from "./enums";

/**
 * Пропсы
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmButton',
  props: {
    variant: {},
    size: { default: TirPmButtonSizeEnum.Big },
    isRounded: { type: Boolean },
    isActive: { type: Boolean },
    isPressed: { type: Boolean },
    isLoading: { type: Boolean },
    isDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



/**
 * Открытие слотов
 */
const slots = useSlots();

/**
 * Есть ли слот слева
 */
const isLeft = computed(() => slots && slots.leftSlot && slots.leftSlot());
/**
 * Есть ли слот справа
 */
const isRight = computed(() => slots && slots.rightSlot && slots.rightSlot());
/**
 * Есть ли слот для текста
 */
const isSign = computed(() => slots && slots.default && slots.default());
/**
 * Есть ли слот для текста подсказки
 */
const isHintText = computed(() => slots && slots.hintText && slots.hintText());

/**
 * Выделение классов на основе пропсов
 */
const calculateClasses = computed(() => {
  return {
    "button--rounded": props.isRounded,
    "button--big": props.size == TirPmButtonSizeEnum.Big,
    "button--regular": props.size == TirPmButtonSizeEnum.Regular,
    "button--middle": props.size == TirPmButtonSizeEnum.Middle,
    "button--small": props.size == TirPmButtonSizeEnum.Small,
    "button--primary": props.variant == TirPmButtonVariantEnum.PrimaryState,
    "button--accent": props.variant == TirPmButtonVariantEnum.AccentState,
    "button--link": props.variant == TirPmButtonVariantEnum.LinkState,
    "button--tertiary": props.variant == TirPmButtonVariantEnum.TertiaryState,
    "button--secondary": props.variant == TirPmButtonVariantEnum.SecondaryState,
    "button--link-invert": props.variant == TirPmButtonVariantEnum.LinkInvertState,
    "button--disabled": props.isDisabled,
    "button--only-icon": isOnlyIcon.value,
    "button--active": props.isActive,
    "button--pressed": props.isPressed,
    "button--loading": props.isLoading,
  };
});

/**
 * Проверка, есть ли текст или только иконка
 */
const isOnlyIcon = computed(
  () =>
    !(slots && slots.default && slots.default()) &&
    !(slots && slots.rightSlot && slots.rightSlot()),
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", calculateClasses.value])
  }, [
    (isLeft.value && !props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "leftSlot")
        ]))
      : _createCommentVNode("", true),
    (isSign.value && !props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          (isHintText.value && !props.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _renderSlot(_ctx.$slots, "hintText")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isRight.value && !props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "rightSlot")
        ]))
      : _createCommentVNode("", true),
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ], 2))
}
}

})